// extracted by mini-css-extract-plugin
export default {"bar":"style_bar__0drP1","title":"style_title__HjPg2"};